import { Tabs, Tab, Box, Badge } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
const CustomInterpreterTabs = ({ tabValue, onChange, interpreterTabs, interpreterDetails }) => {
    const hasPendingApproval = interpreterDetails?.user_languages?.some(lang =>
        lang?.certificates?.some(cert => cert.status === 0)
    );


    return (
        <Tabs value={tabValue} onChange={onChange} aria-label="interpreterTabs-tabs" variant="scrollable"
            scrollButtons="auto"
            allowScrollButtonsMobile>
            {interpreterTabs?.map((tab, index) => {
                const isApprovedTab = tab.label === 'Approved Details';

                return (
                    <Tab
                        key={index}
                        label={
                            isApprovedTab && hasPendingApproval ? (
                                <Badge
                                    color="error"
                                    variant="dot"
                                    overlap="rectangular"
                                    
                                    sx={{
                                        '& .MuiBadge-dot': {
                                            height: 5,
                                            minWidth: 5,
                                            top: 6,
                                            right: -6,
                                        },
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            fontFamily: 'Outfit',
                                            fontSize: '16px',
                                            lineHeight: 1,
                                            pl: 0.5,
                                        }}
                                    >
                                        {tab.label}
                                    </Box>
                                </Badge>
                            ) : (
                                <Box
                                    sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        fontFamily: 'Outfit',
                                        fontSize: '16px',
                                        lineHeight: 1,
                                        pl: 0.5,
                                    }}
                                >
                                    {tab.label}
                                </Box>
                            )
                        }

                        sx={{
                            textTransform: 'capitalize',
                            fontFamily: 'Outfit',
                            fontSize: '16px',
                            backgroundColor: tabValue === index ? 'transparent' : 'transparent',
                            borderRadius: '5px 5px 0px 0px',
                            color: tabValue === index ? 'rgba(0, 151, 178, 1)' : 'inherit',
                            '&:hover': {
                                backgroundColor: tabValue === index ? 'transparent' : 'transparent',
                            },
                        }}
                    />
                );
            })}
        </Tabs>
    );
};

export default CustomInterpreterTabs;
